import type { TOC } from '@ember/component/template-only';

const DashIfEmpty: TOC<{
  Args: { value: string };
  Blocks: { default: [] };
}> = <template>
  {{#if @value}}
    {{#if (has-block)}}
      {{yield}}
    {{else}}
      {{@value}}
    {{/if}}
  {{else}}
    <span class='empty-dash'>—</span>
  {{/if}}
</template>;

export default DashIfEmpty;
